<template>
  <div>
    <div class="row no-gutters">
      <Nav
        v-if="$store.state.auth.user"
        class="d-none d-lg-block col-lg-3 col-xl-2"
      />
      <div :class="$store.state.auth.user ? 'col-lg-9 offset-lg-3 col-xl-10 offset-xl-2 ps-0' : 'col'">
        <Header v-if="$store.state.auth.user" />
        <div class="container-fluid">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from '@/components/NavComponent'
import Header from '@/components/HeaderComponent'

export default {
  components: {
    Nav,
    Header
  },

  onIdle () {
    this.$store.dispatch('auth/logout')
    this.$keycloak.logout()
    location.reload()
  }
}
</script>

<style scoped lang="scss">
  html,
  body {
    -webkit-tap-highlight-color: transparent;
    text-rendering: optimizeLegibility;
    font-size: 14px;
  }
</style>
